import { create } from "zustand";

type ApolloClientState = {
  isApolloClientReady: boolean;
  setIsApolloClientReady: (isApolloClientReady: boolean) => void;
};

export const useApolloClientStore = create<ApolloClientState>()(set => ({
  isApolloClientReady: false,
  setIsApolloClientReady: (isApolloClientReady: boolean) => set({ isApolloClientReady }),
}));
